import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { SearchModel, TabsSearchSetModel } from '@flocasts/experience-service-types'
import { SearchFiltersService } from 'src/app/singleton-services/search-filters.service'

@Component({
  selector: 'flo-tabs-search-set',
  templateUrl: './tabs-search-set.component.html',
  styleUrls: [
    './tabs-search-set.component.scss',
    './styles/search-page-tabs-search-set.component.scss',
    './styles/favorites-page-tabs-search-set.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsSearchSetComponent {
  constructor(private searchFiltersService: SearchFiltersService) {}
  @Input()
  tabsSearchSet: TabsSearchSetModel

  @Output() searchTerm = new EventEmitter<string>()

  public handleSearch(search: { searchTerm: string | null; searchModel?: SearchModel }) {
    this.searchFiltersService.updateQueryParams({ search: search.searchTerm, offset: 0, page: 1 })
  }
}
